import { render, staticRenderFns } from "./DesktopLessonStepItem.vue?vue&type=template&id=04ba4bf0&scoped=true&"
import script from "./DesktopLessonStepItem.vue?vue&type=script&lang=js&"
export * from "./DesktopLessonStepItem.vue?vue&type=script&lang=js&"
import style0 from "./DesktopLessonStepItem.vue?vue&type=style&index=0&id=04ba4bf0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ba4bf0",
  null
  
)

export default component.exports